import { ComponentBase } from '@abstracts/component-base';
import { Component, EventEmitter, Inject, Injector, OnInit, Output } from '@angular/core';
import { IEntity } from '@interfaces/entity';
import { IDto } from '@interfaces/dto';
import { EntityService } from '@services/entity/entity.service';
import { FormService } from '@services/form/form.service';
import { MessageService } from '@services/message/message.service';
import { ToastService } from '@services/toast/toast.service';

@Component({
  selector: 'app-create-entity',
  template: ''
})
export abstract class AbstractCreateEntityComponent extends ComponentBase implements OnInit {

  @Output() newEntityEvent = new EventEmitter<IEntity>();
  @Output() newDtoEvent = new EventEmitter<IDto>();

  @Inject(FormService)
  public formService: FormService;

  @Inject(MessageService)
  public messageService: MessageService;

  @Inject(MessageService)
  public toastService: ToastService;

  constructor(private entitiesService: EntityService, injector: Injector) {
    super(injector);
    this.formService = injector.get(FormService);
    this.messageService = injector.get(MessageService);
  }

  abstract createForm();
  abstract onSubmit(formValue);

  public ngOnInit() {
    super.ngOnInit();
    this.createForm();
  }

  public createEntity(entity: IEntity, params?) {
    this.entitiesService.createEntity(entity, params).subscribe(data => {
      this.newEntityEvent.emit(entity);
    }, error => {
        this.messageService.setError(error);
    });
  }
}
